export const environment = {
  production: false,
  hasuraUrl: 'https://hasura.m2.vitrineretail.dev/v1/graphql', // TODO: voltar pra .com quando swap tiver dados em PROD
  hasuraWsUrl: 'wss://hasura.m2.vitrineretail.dev/v1/graphql',
  loginUrl: 'https://api.vitrineretail.app/api/login',
};
